var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({class:_vm.inputClasses,attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }